import { Book } from './Book';

export class BooksCategories {
    bookId: number;
    bibliographyCategoryId: number;
    
}